import { makeFetchSuccessActionType } from '@/utils/makeActionType';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { GET_ENUM_LIST_MAP } from '../actions/common';
import { HttpStatusCode } from '@/fetch/core/constant';
import { CommonEnumKey } from '@/utils/enum';

const initState: Record<string, any> = {};

Object.values(CommonEnumKey).forEach((enumKey) => {
  initState[enumKey] = null;
});

const enumTranslator = createSlice({
  name: 'enumTranslator',
  initialState: initState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(
      makeFetchSuccessActionType(GET_ENUM_LIST_MAP),
      (state, action: PayloadAction<any>) => {
        const res = action.payload;
        if (res?.code === HttpStatusCode.Success) {
          Object.values(CommonEnumKey).forEach((enumKey) => {
            state[enumKey] = res?.data?.[enumKey];
          });
          localStorage.setItem('ENUM_LIST_MAP', JSON.stringify(res?.data));
        }
      }
    );
  },
});

export default enumTranslator.reducer;
